var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar"},[_c('button',{class:{
      mapButton: true,
      active: _vm.mode === 'map',
    },on:{"click":function($event){return _vm.$emit('change', 'map')}}},[_vm._v(" Kart ")]),_c('button',{class:{
      listButton: true,
      active: _vm.mode !== 'map',
    },on:{"click":function($event){return _vm.$emit('change', 'list')}}},[_vm._v(" Liste ")])])}
var staticRenderFns = []

export { render, staticRenderFns }